import { Controller } from "@hotwired/stimulus";

/** Keeps at most one <details> open among targets; closes on outside click. */
export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.outsideClick = this.outsideClick.bind(this);
    this.toggleHandler = (event) => {
      const current = event.currentTarget;
      if (!current.open) return;
      this.menuTargets.forEach((d) => {
        if (d !== current) d.removeAttribute("open");
      });
    };
    document.addEventListener("click", this.outsideClick, true);
    this.menuTargets.forEach((el) => {
      el.addEventListener("toggle", this.toggleHandler);
    });
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClick, true);
    this.menuTargets.forEach((el) => {
      el.removeEventListener("toggle", this.toggleHandler);
    });
  }

  outsideClick(event) {
    this.menuTargets.forEach((d) => {
      if (d.open && !d.contains(event.target)) {
        d.removeAttribute("open");
      }
    });
  }

  close() {
    this.menuTargets.forEach((d) => d.removeAttribute("open"));
  }
}
